import { useContext } from 'react';
import FormContext$1 from './FormContext.js';
import { fieldFormState } from './utils.js';

/**
 * A hook to return form state data
 * @returns {object} The current state of the form relative to this hook
 * @returns {object} `fields` Form field data, either for the entire form or the current level when Object/Array fields are used
 * @returns {object} `errors` Form field errors, either for the entire form or the current level when Object/Array fields are used
 * @returns {object} `parentFields` Form field data for the parent level when Object/Array fields are used
 * @returns {object} `formFields` Form field data for the entire form when Object/Array fields are used
 * @returns {number} `arrayIndex` Index of the current row when used inside an Array field
 *
 */

var useFormState = function useFormState() {
  var context = useContext(FormContext$1);
  return fieldFormState(context);
};

var useFormState$1 = useFormState;

export { useFormState$1 as default };
